import {Events} from "./classes/Events";
// import {GoogleAnalytics} from "./classes/Analytics/GoogleAnalytics";
// import {GoogleTagManager} from "./classes/Analytics/GoogleTagManager";
import {VkPixel} from "./classes/Analytics/VkPixel";
import {YandexMetrika} from "./classes/Analytics/YandexMetrika";
import {YandexCounter} from "./classes/Analytics/YandexCounter";
// import {FacebookPixel} from "./classes/Analytics/FacebookPixel";
import {VkGoal} from "./classes/Analytics/VkGoal";
import {DashaMail} from "./classes/Analytics/DashaMail";

window.events = new Events({
    analytics: {
        // GoogleAnalytics: new GoogleAnalytics(),
        // GoogleTagManager: new GoogleTagManager({id: process.env.MIX_GOOGLE_ANALYTICS_ID}),
        VkPixel: new VkPixel({listId: process.env.MIX_VK_LIST_ID}),
        VkPixel2: new VkPixel({listId: process.env.MIX_VK_LIST_ID2}),
        YandexMetrika: new YandexMetrika(),
        YandexCounter: new YandexCounter({id: process.env.MIX_YANDEX_METRIKA_ID}),
        // FacebookPixel: new FacebookPixel(),
        VkGoal: new VkGoal(),
        DashaMail: new DashaMail(),
    }
});

let viewedProductIds = [],
    products = [],
    order = {};

document.onreadystatechange = () => {
    if (document.readyState === "complete") {

        let data = document.querySelector('[data-page]'),
            headerCartButtons = [].slice.call(document.querySelectorAll('.nav-item--cart .nav-link')),
            phoneButton = [].slice.call(document.querySelectorAll('.header-item--phone'));

        let page = data && data.dataset.page ? data.dataset.page : 'other',
            categoryIds = window.categoryIds ? window.categoryIds : [];

        products = window.products ? _.map(window.products, p => productFormat(p)) : [];
        order = window.order ? window.order : {};

        if (_.isEmpty(categoryIds) && !_.isEmpty(products)) {
            categoryIds = _.filter(_.uniq(_.flatten(_.map(products, 'category_ids'))));
        }

        window.events.onPageLoad({page: page, products: products, categoryIds: categoryIds, order: order});

        if (page === 'product') {
            let id = parseInt(_.get(document.querySelector('.product[data-id]'), 'dataset.id'));
            let item = _.find(products, p => p.id === id);

            if (item) {
                window.events.onLoadDetail({product: item});
            }

        } else if (page === 'cart') {
            window.events.onCheckout({step: 1, products: products});

        } else if (page === 'delivery') {
            window.events.onCheckout({step: 2, products: products});
        }

        if (headerCartButtons.length) {
            headerCartButtons.forEach((el) => {
                el.addEventListener('click', () => {
                    window.events.onClickCart('header');
                });
            });
        }

        if (phoneButton.length) {
            phoneButton.forEach((el) => {

                el.addEventListener('click', () => {

                    if (typeof MeTalk !== 'undefined') {
                        MeTalk('showTab', {id: '9w0hzivuy6g4qmi9'});
                    }
                    window.events.onClickPhone();
                });
            });
        }

        viewedProducts();

        document.onscroll = () => {
            viewedProducts();
        }

        document.addEventListener('click', (e) => {

            setTimeout(() => {
                viewedProducts();
            }, 1500);

            if (!_.includes(e.target.classList, 'card-preview')) {

                let parent = getParentElement(e.target, 'card-item');

                if (parent) {
                    let productId = parseInt(_.get(parent, 'dataset.id'));
                    let clickedProduct = _.find(products, p => p.id === productId);

                    if (clickedProduct) {
                        window.events.onClickProduct({product: clickedProduct});
                    }
                }
            }

            if (e.target) {

                let item = false,
                    productId = 0,
                    selected = 1;

                if (e.target.classList && e.target.classList.contains('product-add-to-cart')) {

                    productId = parseInt(_.get(e.target, 'dataset.id'));

                    if (_.get(e.target, 'dataset.size_required')) {
                        selected = document.querySelectorAll('.product-size-items[data-id="' + productId + '"] .product-size-item.active').length;
                    }

                    if (selected) {
                        item = _.find(products, p => p.id === productId);
                        if (item) {
                            window.events.onAddToCart({product: {...item, ...{quantity: selected}}});
                        }
                    }

                } else if (e.target.parentElement &&
                    e.target.parentElement.classList &&
                    e.target.parentElement.classList.contains('product-add-to-cart')
                ) {

                    productId = parseInt(_.get(e.target.parentElement, 'dataset.id'));

                    if (_.get(e.target.parentElement, 'dataset.size_required')) {
                        selected = document.querySelectorAll('.product-size-items[data-id="' + productId + '"] .product-size-item.active').length;
                    }

                    if (selected) {
                        item = _.find(products, p => p.id === productId);
                        if (item) {
                            window.events.onAddToCart({product: {...item, ...{quantity: selected}}});
                        }
                    }

                } else if (e.target.classList && e.target.classList.contains('size-add-to-card')) {

                    productId = parseInt(_.get(e.target.parentElement, 'dataset.id'));
                    item = _.find(products, p => p.id === productId);

                    if (item) {
                        window.events.onAddToCart({product: {...item, ...{quantity: 1}}});
                    }
                } else if (e.target.classList && e.target.classList.contains('cart-item-remove')) {
                    productId = parseInt(_.get(e.target, 'dataset.id'));
                    item = _.find(products, p => p.id === productId);

                    if (item) {
                        window.events.onRemoveFromCart({products: [item]});
                    }
                } else if (e.target.parentElement &&
                    e.target.parentElement.classList &&
                    e.target.parentElement.classList.contains('cart-item-remove')
                ) {
                    productId = parseInt(_.get(e.target.parentElement, 'dataset.id'));
                    item = _.find(products, p => p.id === productId);

                    if (item) {
                        window.events.onRemoveFromCart({products: [item]});
                    }
                } else if (e.target.parentElement &&
                    e.target.parentElement.parentElement &&
                    e.target.parentElement.parentElement.classList &&
                    e.target.parentElement.parentElement.classList.contains('cart-item-remove')
                ) {
                    productId = parseInt(_.get(e.target.parentElement.parentElement, 'dataset.id'));
                    item = _.find(products, p => p.id === productId);

                    if (item) {
                        window.events.onRemoveFromCart({products: [item]});
                    }
                }
            }
        });

        setTimeout(function () {
            if (document.getElementById('location-city-name')
                && document.getElementById('location-city-name').textContent === 'Не определено'
            ) {
                window.events.onLocationUndefined();
            }
        }, 2000);
    }
}

const viewedProducts = () => {
    let ids = _.map(_.filter(
        document.querySelectorAll('.card-item[data-id]'), (el) => el instanceof HTMLElement && isVisible(el)
    ), (p) => parseInt(p.dataset.id));

    let visibleProducts = _.map(_.filter(products, p => ids.includes(p.id)), p => p);

    if (visibleProducts.length) {

        let loadedProducts = _.uniqWith(_.filter(visibleProducts, (p) => !viewedProductIds.includes(p.id)), _.isEqual);
        viewedProductIds = _.uniq(viewedProductIds.concat(ids));

        if (loadedProducts.length) {
            window.events.onLoadImpressions({products: loadedProducts});
        }
    }
}

const productFormat = (product) => {

    let category = product.category ? product.category :
            _.isString(product.primary_category) ? product.primary_category : _.get(product.primary_category, 'name', ''),
        brand = _.isString(product.brand) ? product.brand : _.get(product.brand, 'name', ''),
        name = product.name ? product.name : category + ' ' + brand + ' ' + product.article;

    return {
        id: product.id,
        name: name,
        price: product.selling_price ? product.selling_price : product.price,
        category: category,
        brand: product.brand,
        category_ids: product.category_ids,
    }
}

const getParentElement = (el, className) => {
    if (el.classList && el.classList.contains(className))
        return el;

    if (el.parentNode && getParentElement(el.parentNode, className)) {
        return el.parentNode;
    }
}
